<script lang="ts">
  import { ErrorView, Title } from '$shared/components';
  import Logo from '$shared/images/verifiable-logo-full.svg';
  import ProvidedInfo from './partials/ProvidedInfo.svelte';
  import Result from './partials/Result.svelte';
  import type { PrintData } from '$shared/models/PrintData';
  import Screenshots from './partials/Screenshots.svelte';

  interface Props {
    data: PrintData | undefined;
  }

  let { data }: Props = $props();
</script>

{#if data}
  <div class="print-template">
    <div id="reportHeader" class="header">
      <div class="prepared-date">{data.reportType} - {data.preparedOn}</div>
      <div class="logo"><img src={Logo} alt="Verifiable" /></div>
      <div class="title"><Title type="h2">{data.title}</Title></div>
      {#if data.subTitle}
        <div class="subTitle"><Title type="h4">{data.subTitle}</Title></div>
      {/if}
      {#if data.subDesc}
        <div class="subDesc">{data.subDesc}</div>
      {/if}
      <div class="header-sec">
        <div class="source">
          {#if data.sourceUrl}
            <div class="url">
              Source: <a href={data.sourceUrl}>{data.source || data.sourceUrl}</a>
            </div>
          {:else if data.source}
            <div class="label">Source: {data.source}</div>
          {/if}
        </div>
        {#if data.status}
          <div class="status">
            <div class="label">Status:</div>
            <div class="value">{data.status}</div>
          </div>
        {/if}
      </div>
    </div>
    <div class="container">
      <div class="page content">
        <div class="sec-left">
          <Result {data} />
        </div>
        <div class="sec-right">
          <ProvidedInfo {data} />
        </div>
      </div>
    </div>
    {#if !data.isNotFound}
      <div class="screenshot-wrap">
        <Screenshots list={data.screenshots} />
      </div>
    {/if}
  </div>
{:else}
  <ErrorView label="Invalid Print Data" />
{/if}

<style src="./PrintTemplate.css">
</style>
